import { LoadingBall } from '#src/components/icons/LoadingBall.tsx';

const styles = {
  loadingBall: {
    margin: 'auto',
  },
};

export const CenteredLoadingBall = () => (
  <div
    style={{
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      height: '100%',
    }}
  >
    <LoadingBall style={styles.loadingBall} />
  </div>
);
